import dic from '@/assets/dictionary/index.js'
import { LANG } from '@/libs/constants'

const { partners } = dic[LANG]
export const newPartners = (partners) => [
  {
    id: 1,
    description: [partners.list[1].description],
    only: true,
    imgUrl: 'vchasno.webp',
    imgClassicUrl: 'vchasno.png',
  },
  {
    id: 2,
    description: [partners.list[2].description],
    only: false,
    imgUrl: 'spilka.webp',
    imgClassicUrl: 'spilka.png',
  },
]

export default {
  namespaced: true,
  state: {
    partners: newPartners(partners),
  },
}
